const operationLevelList = Object.freeze([
  {
    no: 1,
    operation_level: "1",
    mark: "○",
    guide: "全ての情報について操作権、参照権あり"
  },
  {
    no: 2,
    operation_level: "4", // 2,
    mark: "●",
    guide: "全ての情報について削除以外の操作権（登録・編集）、参照権あり"
  },
  {
    no: 3,
    operation_level: "5", // 3,
    mark: "□",
    guide: "所属自治体の操作権あり、他自治体の参照権あり"
  },
  {
    no: 4,
    operation_level: "6", // 4,
    mark: "☒",
    guide:
      "所属自治体の削除以外の操作権（登録・編集）あり、他自治体の参照権あり"
  },
  {
    no: 5,
    operation_level: "7", // 5,
    mark: "■",
    guide: "所属自治体の操作権あり、他自治体の参照権なし"
  },
  {
    no: 6,
    operation_level: "8", // 6,
    mark: "▣",
    guide:
      "所属自治体の削除以外の操作権（登録・編集）あり、他自治体の参照権なし"
  },
  {
    no: 7,
    operation_level: "9", // 7,
    mark: "△",
    guide: "所属自治体の参照権あり、他自治体の参照権あり"
  },
  {
    no: 8,
    operation_level: "10", // 8,
    mark: "▲",
    guide: "所属自治体の参照権あり、他自治体の参照権なし"
  },
  {
    no: 9,
    operation_level: "15", // 9,
    mark: "◈",
    guide: "所属部署の操作権あり、他所属部署の参照権あり"
  },
  {
    no: 10,
    operation_level: "11", // 10,
    mark: "◇",
    guide: "所属部署の操作権のみあり"
  },
  {
    no: 11,
    operation_level: "12", // 11,
    mark: "▦",
    guide: "所属部署の削除以外の操作権（登録・編集）のみあり"
  },
  {
    no: 12,
    operation_level: "13", // 12,
    mark: "◆",
    guide: "所属部署の参照権のみあり"
  },
  {
    no: 13,
    operation_level: "14", // 13,
    mark: "✕",
    guide: "対象外"
  }
]);
// 操作権限パターン一覧
const operationType = Object.freeze({
  type1: [
    "1",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15"
  ],
  type2: ["1", "4", "5", "6", "7", "8", "9", "10", "14"],
  type3: ["1", "4", "9", "14"],
  type4: ["1", "9", "14"],
  type5: ["1", "14"],
  type6: ["1"]
});
// 画面グループIDリスト（所属画面ID群、許可された操作権リスト含む）
const screenIdGroupList = Object.freeze([
  // WEBアプリ画面側
  {
    screenGroupId: "SFG001",
    screenGroupName: "トップ／メニュー",
    belongsScreenIdList: ["SF0101", "SF1601", "SF1602", "SF0102"],
    permittedOperation: operationType.type6,
    operation_level: "1" //新規登録ダイアログでのデフォルト値
  },
  {
    screenGroupId: "SFG002",
    screenGroupName: "災害名称管理",
    belongsScreenIdList: ["SF0201", "SF0202", "SF0203", "SF0204", "SF0205"],
    permittedOperation: operationType.type3,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG003",
    screenGroupName: "OIL管理",
    belongsScreenIdList: ["SF2001"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG004",
    screenGroupName: "住民向け広報管理",
    belongsScreenIdList: [
      "SF0301",
      "SF0302",
      "SF0303",
      "SF0304",
      "SF0305",
      "SF0306",
      "SF0308"
    ],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG005",
    screenGroupName: "Lアラート管理",
    belongsScreenIdList: ["SF2101", "SF2102", "SF2103", "SF2104", "SF2105"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG006",
    screenGroupName: "クロノロジー情報管理",
    belongsScreenIdList: ["SF0402", "SF0403", "SF0404", "SF0405", "SF0406"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG007",
    screenGroupName: "ＱＲコード発行単位管理（要配慮者施設）",
    belongsScreenIdList: ["SF0601"],
    permittedOperation: operationType.type1,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG008",
    screenGroupName: "ＱＲコード登録（要配慮者施設）",
    belongsScreenIdList: ["SF0602", "SF0603"],
    permittedOperation: operationType.type1,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG009",
    screenGroupName: "ＱＲコード発行単位管理（学校）",
    belongsScreenIdList: ["SF0604"],
    permittedOperation: operationType.type1,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG010",
    screenGroupName: "ＱＲコード登録（学校）",
    belongsScreenIdList: ["SF0605", "SF0606"],
    permittedOperation: operationType.type1,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG011",
    screenGroupName: "仮ＱＲコード発行単位管理",
    belongsScreenIdList: ["SF0607"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG012",
    screenGroupName: "仮ＱＲコード登録",
    belongsScreenIdList: ["SF0608", "SF0609"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG013",
    screenGroupName: "バスＱＲコード印刷",
    belongsScreenIdList: ["SF0610"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG014",
    screenGroupName: "安定ヨウ素剤配布状況一覧",
    belongsScreenIdList: ["SF1001"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG015",
    screenGroupName: "安定ヨウ素剤事前配布状況個人検索",
    belongsScreenIdList: ["SF1002"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG016",
    screenGroupName: "ユーザ情報管理",
    belongsScreenIdList: ["SF1201", "SF1202", "SF1203", "SF1207"],
    permittedOperation: operationType.type3,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG017",
    screenGroupName: "操作権管理",
    belongsScreenIdList: ["SF1204", "SF1205", "SF1206", "SF1208"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG018",
    screenGroupName: "原子力災害関係施設マスタ管理",
    belongsScreenIdList: ["SF1401", "SF1404", "SF1409", "SF1403", "SF1402"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG019",
    screenGroupName: "要配慮者施設マスタ管理",
    belongsScreenIdList: ["SF1501", "SF1504", "SF1509", "SF1503", "SF1502"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG020",
    screenGroupName: "災害配信定型文マスタ管理",
    belongsScreenIdList: ["SF3001", "SF3004", "SF3009", "SF3003", "SF3002"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG021",
    screenGroupName: "情報ガイドマスタ管理",
    belongsScreenIdList: ["SF3101", "SF3104", "SF3109", "SF3103", "SF3102"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG022",
    screenGroupName: "避難所状況管理",
    belongsScreenIdList: ["SF1301"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG023",
    screenGroupName: "避難者状況管理",
    belongsScreenIdList: ["SF1303"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG024",
    screenGroupName: "施設状況管理（原子力災害関係）",
    belongsScreenIdList: ["SF1405", "SF1406", "SF1407", "SF1408"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG025",
    screenGroupName: "施設状況管理（要配慮者施設）",
    belongsScreenIdList: ["SF1505", "SF1506", "SF1507", "SF1508"],
    permittedOperation: operationType.type1,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG026",
    screenGroupName: "防災関係者向け広報管理",
    belongsScreenIdList: ["SF1801", "SF1802", "SF1803"],
    permittedOperation: operationType.type2,
    operation_level: "14"
  },
  //スマホアプリ
  {
    screenGroupId: "SFG027",
    screenGroupName: "地図表示",
    belongsScreenIdList: ["SF9001"],
    permittedOperation: operationType.type3,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG028",
    screenGroupName: "ログイン",
    belongsScreenIdList: ["SF5001"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG029",
    screenGroupName: "作業場所選択",
    belongsScreenIdList: ["SF5005"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG030",
    screenGroupName: "入所退所QRコード読み込み",
    belongsScreenIdList: ["SF5007"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG031",
    screenGroupName: "避難者検索",
    belongsScreenIdList: ["SF5008"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG032",
    screenGroupName: "バス乗車/降車登録",
    belongsScreenIdList: ["SF5016"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG033",
    screenGroupName: "バス情報確認",
    belongsScreenIdList: ["SF5011"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG034",
    screenGroupName: "安定ヨウ素剤配布QRコード読み込み",
    belongsScreenIdList: ["SF5021"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG035",
    screenGroupName: "安定ヨウ素剤配布状況",
    belongsScreenIdList: ["SF5029"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG036",
    screenGroupName: "通知",
    belongsScreenIdList: ["SF5023"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG037",
    screenGroupName: "設定",
    belongsScreenIdList: ["SF5026"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG038",
    screenGroupName: "車両管理",
    belongsScreenIdList: ["SF1701"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG039",
    screenGroupName: "防災資機材の配備状況取込",
    belongsScreenIdList: ["SF1902"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG040",
    screenGroupName: "安定ヨウ素剤の事前配布状況取込",
    belongsScreenIdList: ["SF1903"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG041",
    screenGroupName: "避難退域時検査場所状況表示",
    belongsScreenIdList: ["SF1904"],
    permittedOperation: operationType.type5,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG042",
    screenGroupName: "DPND連携",
    belongsScreenIdList: ["SF1901"],
    // DPND連携の操作権限許可リストは画面初期処理時にDBより取得し生成する
    permittedOperation: [],
    operation_level: "14"
  },
  {
    screenGroupId: "SFG043",
    screenGroupName: "自治会マスタ",
    belongsScreenIdList: ["SF4001","SF4002","SF4003","SF4004","SF4005"],
    permittedOperation: operationType.type4,
    operation_level: "14"
  },
  {
    screenGroupId: "SFG044",
    screenGroupName: "調整システム",
    belongsScreenIdList: [
      "SF4101",
      "SF4102",
      "SF4103",
      "SF4104",
      "SF4201",
      "SF4202",
      "SF4203",
      "SF4204",
      "SF4205",
      "SF4206",
      "SF4207"
    ],
    permittedOperation: operationType.type5,
    operation_level: "14"
  }
]);
// 画面グループごとのドロップダウンリスト生成
const selectList = () => {
  let result = [];
  screenIdGroupList.forEach(item => {
    let res = operationLevelList.filter(val =>
      item.permittedOperation.includes(val.operation_level)
    );
    result[item.screenGroupId] = res;
  });
  return result;
};
// 画面グループの代表画面IDを取得
const getRepresentScreenId = () => {
  let result = [];
  screenIdGroupList.forEach(item => {
    let res = {};
    res.screenGroupId = item.screenGroupId;
    res.representScreenId = item.belongsScreenIdList[0];
    result.push(res);
  });
  return result;
};

export {
  operationLevelList,
  screenIdGroupList,
  operationType,
  selectList,
  getRepresentScreenId
};
